import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ImportersApi } from 'api';

/**
 * Custom React Query hook that handles the creation of users.
 *
 * @param {"single" | "batch"} type
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult<any, unknown, any, unknown>}
 */
export function useCreateUsers(type = 'single', { onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      if (type === 'batch') {
        return ImportersApi.batchAdd(data);
      }

      return ImportersApi.add(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
}
